import { useField } from 'formik';

import {
    SupplierCompanyMultiSelect,
    type SupplierCompanyMultiSelectProps,
} from '../CompanySelect/SupplierCompanyMultiSelect';

interface FormikSupplierCompanyMultiSelectProps extends Omit<SupplierCompanyMultiSelectProps, 'onChange' | 'value'> {
    name: string;
}

export function FormikSupplierCompanyMultiSelect(props: FormikSupplierCompanyMultiSelectProps) {
    const [field, meta, helpers] = useField<string[]>(props.name);

    const onChange = (supplierIds: string[]) => {
        helpers.setValue(supplierIds);
    };

    return (
        <SupplierCompanyMultiSelect
            {...props}
            onChange={onChange}
            value={field.value}
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error ? meta.error : props.caption}
            onBlur={() => {
                helpers.setTouched(true);
            }}
        />
    );
}
